import { Table } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type AdyenPaymentModuleSpecsFragment } from '../../../../api/fragments/AdyenPaymentModuleSpecs';
import AdyenPaymentSettingActions from './AdyenPaymentSettingActions';

export type AdyenPaymentSettingsTableProps = {
    module: AdyenPaymentModuleSpecsFragment;
};

export type PaymentSettingSpecs = AdyenPaymentModuleSpecsFragment['paymentSettings'][number];

const AdyenPaymentSettingsTable = ({ module }: AdyenPaymentSettingsTableProps) => {
    const { t } = useTranslation(['adyenPaymentModuleDetails']);

    const renderActions = useCallback(
        (record: PaymentSettingSpecs) => <AdyenPaymentSettingActions module={module} paymentSetting={record} />,
        [module]
    );

    return (
        <Table dataSource={module.paymentSettings} rowKey="id">
            <Table.Column
                key="displayName"
                dataIndex="displayName"
                title={t('adyenPaymentModuleDetails:paymentSettingsTable.columns.displayName')}
            />
            <Table.Column
                key="currency"
                dataIndex="currency"
                title={t('adyenPaymentModuleDetails:paymentSettingsTable.columns.currency')}
            />
            <Table.Column
                key="amount"
                dataIndex="amount"
                title={t('adyenPaymentModuleDetails:paymentSettingsTable.columns.amount')}
            />
            <Table.Column
                key="environment"
                dataIndex="environment"
                title={t('adyenPaymentModuleDetails:paymentSettingsTable.columns.environment')}
            />
            <Table.Column
                key="actions"
                align="center"
                render={renderActions}
                title={t('adyenPaymentModuleDetails:paymentSettingsTable.columns.actions')}
                width={100}
            />
        </Table>
    );
};

export default AdyenPaymentSettingsTable;
